'use client';
import React, { useEffect, useRef } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';
import clsx from 'clsx';

type Props = {
  delay?: number;
  duration?: number;
  children: React.ReactNode;
  className?: string;
};

export default function RevealAnimation({
  delay = 0,
  duration = 0.5,
  children,
  className,
}: Props) {
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  useEffect(() => {
    if (isInView) {
      controls.start('visible');
    }
  }, [isInView, controls]);

  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y: 75 },
        visible: { opacity: 1, y: 0 },
      }}
      initial="hidden"
      animate={controls}
      transition={{ duration, delay }}
      ref={ref}
      className={clsx('w-full', className)}
    >
      {children}
    </motion.div>
  );
}
